import { useLocation } from "react-router-dom";
import { getUserData } from "../../Actions/common.js";
import CardDetailsComponent from "../../Sections/CardDetails/index.js";
import UnauthorizedIPPage from "../../utils/UnauthorizedIPPage";
import ChangePasswordComponent from "../Auth/ChangePassword";
import ChangeMasterUserProfile from "../Auth/ChangeProfile";
import Login from "../Auth/Login";
import Dashboard from "../Dashboard/index";
import LoginSessionsComponent from "../loginSessions";
import LogsComponent from "../Logs";
import MasterUsersComponent from "../MasterUsers";
import PlanManagementComponent from "../PlanManagement/index.js";
import PlanPaymentPage from "../PlanPayment/index.js";
import ReportsComponents from "../Reports";
import RoleManagerComponent from "../RoleManager";
import SettingsComponent from "../Settings";
import SupportTicketComponent from "../SupportTicket";
import TemplatesComponent from "../Templates";
import TenantComponent from "../Tenant/index.js";
import TenantAddEditComponent from "../Tenant/TenantAddEditComponent.js";
import TermsAndConditionsComponent from "../TermsAndConditions/index.js";
import TnCComponentComponent from "../TnCComponent/TnCComponent.js";
import TransactionComponent from "../Transaction";
import WhitelistComponent from "../WhiteListIps";
import MailLogsComponent from "../MailLogs/index.js";
import IpBlockedPage from "../Common/IpBlocked.js";
import IpBlockedListComponent from "../IpBlockedList/index.js";
import KnowledgeBaseComponent from "../KnowledgeBase/index.js";
import ModuleListComponent from "../KnowledgeBase/ModuleListPage.js";
import KnowledgeBaseViewComponent from "../KnowledgeBase/KnowledgeBaseViewPage.js";

const RouteManager = () => {
  const location = useLocation();
  const dynamicPath = location.pathname;
  const userData = localStorage.getItem("userData") ? getUserData() : null;

  const publicRoutes = [
    { path: "/login", component: <Login /> },
    { path: "/setup-password", component: <Login /> },
    { path: "/unauthorized-ippage", component: <UnauthorizedIPPage /> },
    { path: "/plan-payment", component: <PlanPaymentPage /> },
    { path: "/card-details", component: <CardDetailsComponent /> },
    { path: "/ip-blocked", component: <IpBlockedPage /> },
  ];

  const privateRoutes =
    userData?.isTermsRead === false
      ? [
          {
            path: dynamicPath,
            component: <TnCComponentComponent />,
          },
        ]
      : [
          { path: "/", component: <Dashboard /> },
          { path: "/dashboard", component: <Dashboard /> },
          {
            path: "/change-password",
            component: <ChangePasswordComponent />,
          },
          { path: "/settings", component: <SettingsComponent /> },
          { path: "/profile", component: <ChangeMasterUserProfile /> },
          {
            path: "/login-sessions",
            component: <LoginSessionsComponent />,
          },
          {
            path: "/users",
            component: <MasterUsersComponent />,
            checkAccess: "canView",
            slug: "users",
          },
          {
            path: "/audit-trail",
            component: <LogsComponent />,
            checkAccess: "canView",
            slug: "audit-trail",
          },
          {
              path:"mail-logs",
              component: <MailLogsComponent/>,
              checkAccess:"canView",
              slug: "mail-logs"
          },
          {
            path: "/role-manager",
            component: <RoleManagerComponent />,
            checkAccess: "canView",
            slug: "roles",
          },
          {
            path: "/reports",
            component: <ReportsComponents />,
            checkAccess: "canView",
            slug: "reports",
          },
          {
            path: "/plan-management",
            component: <PlanManagementComponent />,
            checkAccess: "canView",
            slug: "plan-management",
          },
          {
            path: "/transactions",
            component: <TransactionComponent />,
            checkAccess: "canView",
            slug: "transaction",
          },
          {
            path: "/tenant",
            component: <TenantComponent />,
            checkAccess: "canView",
            slug: "onboarding-tenant",
          },
          {
            path: "/tenant/add",
            component: <TenantAddEditComponent />,
            checkAccess: "canCreate",
            slug: "onboarding-tenant",
          },
          {
            path: "/tenant/edit/",
            component: <TenantAddEditComponent />,
            checkAccess: "canEdit",
            slug: "onboarding-tenant",
          },
          {
            path: "/whitelist-ips",
            component: <WhitelistComponent />,
            checkAccess: "canView",
            slug: "ip-whitelist",
          },
          {
            path: "/templates",
            component: <TemplatesComponent />,
            checkAccess: "canView",
            slug: "templates",
          },
          {
            path: "/support-ticket",
            component: <SupportTicketComponent />,
            checkAccess: "canView",
            slug: "support-ticket",
          },
          {
            path: "/terms-conditions",
            component: <TermsAndConditionsComponent />,
          },
          {
            path: "/ip-blocked",
            component: <IpBlockedListComponent />,
            checkAccess: "canView",
            slug: "ip-blocked",
          },
          {
            path: "/knowledge-base",
            component: <KnowledgeBaseComponent />,
            checkAccess: "canView",
            slug: "knowledge-base",
          },
          {
            path: "/knowledge-base/:moduleSlug",
            component: <ModuleListComponent />,
            checkAccess: "canView",
            slug: "knowledge-base",
          },
          {
            path: "/knowledge-base/:moduleSlug/:knowledgeBaseId",
            component: <KnowledgeBaseViewComponent />,
            checkAccess: "canView",
            slug: "knowledge-base",
          },
        ];

  return { location, privateRoutes, publicRoutes };
};

export default RouteManager;
